var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100vh"}},[_c('pdf-view',{attrs:{"uri":_vm.uri,"width":"100%","height":"100%"},on:{"download-file":_vm.downloadFile}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }